export default function parseStringTime(timeString: string) {
  const [aHour, aMin, aSec, frame] = timeString
    .split(":")
    .map((v) => parseInt(v))

  // Return seconds
  return aHour * 3600 + aMin * 60 + aSec + frame / 30
}
